import SectionLatestListings from './SectionLatestListings';
export default SectionLatestListings;
